import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons';

export function getBookingIconColor(status: string) {
  if(!status) return 'lightGreen';

  switch (status) {
    case 'CANCELLED':
      return 'beanRed';

    case 'UPCOMMING_RENTAL':
      return 'green';

    default:
	  return 'disabledGray';
  }
}

export function getUploadIcon(complete: boolean, status: string) {
  if(complete && (!status || status === 'UPCOMMING_RENTAL'))
  	return (
		<CheckCircleFilled className="text-green mr-8" style={{ fontSize: 24 }} />
		);
   if(complete && (status !== 'UPCOMMING_RENTAL'))
  	return (
		<div className="w-[24px] h-[24px] bg-disabledGray rounded-full mr-8" />
		);

  if(!complete && (!status || status !== 'UPCOMMING_RENTAL'))
  	return (<CloseOutlined
          className="text-beanRed mr-8"
          style={{ fontSize: 24 }}
        />);
}
